// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__capVb","content":"styles_content__1Pj__","selectAll":"styles_selectAll__1qdGl"};